import React from 'react';
// import BgCta from '../../images/wpo-cta-bg.jpg'
import { Link } from 'react-router-dom';

const CtaSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className={"" + props.hclass}  style={{ backgroundImage:`url(${`https://res.cloudinary.com/dexvxngzg/image/upload/v1764569680/wpo-cta-bg.d9aa621a2b57c8961514_e7fanv.jpg`})`}}>
            <div className="title">
                <h2 className="poort-text poort-in-right">Let’s Build Your Dream Together</h2>
                <Link onClick={ClickHandler} to="/contact"><span>Get A Quote</span> <i className="ti-arrow-right"></i></Link>
            </div>
        </section>
    );
};

export default CtaSection;